import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { BasemapSwitcherNotifier } from './basemap-switcher-notifier';
import { BasemapSwitcherState } from './basemap-switcher-state';

@Injectable()
export class BasemapSwitcherProvider extends BaseProvider<BasemapSwitcherNotifier, BasemapSwitcherState> {
  constructor() {
    super(BasemapSwitcherNotifier);
  }
}
